export enum AdminAuditEventCategory {
    ACCOUNTS = 'EMA Accounts',
    EMAIL_DOMAINS = 'Email Domain',
    ENTERPRISE_PREFERENCES = 'Enterprise Preferences',
    MFA = 'Multifactor Authentication',
    PASSWORDS = 'Passwords',
    SITES = 'Sites',
    USERS = 'Universal IDs',
    AUDIT_REPORTS = 'Audit Reports'
}
